import { MessageCircle, FileSearch } from "lucide-react";
import { ButtonGold, ButtonGhost } from "./Buttons";
import { Eyebrow, Reveal } from "./Reveal";
import { WHATSAPP_URL } from "../config";

export default function FinalCTA({ onOpenForm }) {
    return (
        <section className="relative overflow-hidden px-6 py-28 lg:px-10 lg:py-40" data-testid="final-cta-section">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(201,162,39,0.08),transparent_60%)]" />
            <Reveal>
                <div className="relative mx-auto max-w-3xl border border-gold-faint bg-[#0a0a0a]/70 px-8 py-16 text-center backdrop-blur-sm lg:px-16">
                    {/* corner ticks */}
                    <span className="absolute left-0 top-0 h-4 w-4 border-l border-t border-gold" />
                    <span className="absolute right-0 top-0 h-4 w-4 border-r border-t border-gold" />
                    <span className="absolute bottom-0 left-0 h-4 w-4 border-b border-l border-gold" />
                    <span className="absolute bottom-0 right-0 h-4 w-4 border-b border-r border-gold" />

                    <Eyebrow className="justify-center">Passo Final</Eyebrow>
                    <h2
                        className="mx-auto mt-7 max-w-xl font-serif text-3xl leading-tight text-white sm:text-4xl lg:text-5xl"
                        data-testid="final-cta-headline"
                    >
                        Pare de tentar <em className="italic text-gold">adivinhar</em> onde
                        está o problema.
                    </h2>
                    <p
                        className="mx-auto mt-7 max-w-xl text-lg font-light leading-relaxed text-[#e6e6e6]"
                        data-testid="final-cta-subheadline"
                    >
                        Deixe o MasterClaus encontrar as evidências, calcular o seu sangramento
                        financeiro e entregar o mapa da recuperação.
                    </p>
                    <div className="mt-11 flex flex-col items-center justify-center gap-4 sm:flex-row">
                        <ButtonGold href={WHATSAPP_URL} tid="final-cta-whatsapp">
                            <MessageCircle size={15} />
                            Falar com o Investigador no WhatsApp
                        </ButtonGold>
                        <ButtonGhost onClick={onOpenForm} tid="final-cta-form">
                            <FileSearch size={15} />
                            Solicitar Esboço Gratuito
                        </ButtonGhost>
                    </div>
                </div>
            </Reveal>
        </section>
    );
}
